import { CapturedPiece } from "./CapturedPiece";

import { PlayerCapsule } from "./PlayerCapsule";

import { GameVars } from "../../GameVars";

import { GameConstants } from "../../GameConstants";

import { Piece } from "../Piece";

import { BoardState } from "../BoardState";

export class CapturedPiecesContainer extends Phaser.Group {

    public color: string;

    private pawnCapturedIcon: CapturedPiece;
    private knightCapturedIcon: CapturedPiece;
    private bishopCapturedIcon: CapturedPiece;
    private rookCapturedIcon: CapturedPiece;
    private queenCapturedIcon: CapturedPiece;
    private isPlayer: boolean;
    private playerCapsule: PlayerCapsule;
    
    constructor(game: Phaser.Game, isPlayer: boolean, playerCapsule: PlayerCapsule) {

        super(game, null, "captured-pieces-container");

        this.isPlayer = isPlayer;
        this.playerCapsule = playerCapsule;

        if (this.isPlayer) {
            this.color = GameVars.colorPlayer;
        } else {
            this.color = GameVars.colorPlayer === GameConstants.WHITE ? GameConstants.BLACK : GameConstants.WHITE;
        }

        this.pawnCapturedIcon = new CapturedPiece(this.game, this.color === GameConstants.WHITE ? GameConstants.BLACK_PAWN : GameConstants.WHITE_PAWN);
        this.add(this.pawnCapturedIcon);

        this.knightCapturedIcon = new CapturedPiece(this.game, this.color === GameConstants.WHITE ? GameConstants.BLACK_KNIGHT : GameConstants.WHITE_KNIGHT);
        this.add(this.knightCapturedIcon);

        this.bishopCapturedIcon = new CapturedPiece(this.game, this.color === GameConstants.WHITE ? GameConstants.BLACK_BISHOP : GameConstants.WHITE_BISHOP);
        this.add(this.bishopCapturedIcon);

        this.rookCapturedIcon = new CapturedPiece(this.game, this.color === GameConstants.WHITE ? GameConstants.BLACK_ROOK : GameConstants.WHITE_ROOK);
        this.add(this.rookCapturedIcon);

        this.queenCapturedIcon = new CapturedPiece(this.game, this.color === GameConstants.WHITE ? GameConstants.BLACK_QUEEN : GameConstants.WHITE_QUEEN);
        this.add(this.queenCapturedIcon);

        this.configurePositions();

        this.configurePieceIcons();

        this.alpha = 0;

        this.game.add.tween(this)
            .to({alpha: 1}, 350, Phaser.Easing.Cubic.Out, true, 700);
    }

    public addCapturedPiece(capturedPiece: Piece): void {
        
        let icon: CapturedPiece;

        switch (capturedPiece.pieceType) {
            case GameConstants.BLACK_PAWN:
            case GameConstants.WHITE_PAWN:
                icon = this.pawnCapturedIcon;
                break;
            case GameConstants.BLACK_KNIGHT:
            case GameConstants.WHITE_KNIGHT:
                icon = this.knightCapturedIcon;
                break;
            case GameConstants.BLACK_BISHOP:
            case GameConstants.WHITE_BISHOP:
                icon = this.bishopCapturedIcon;
                break;
            case GameConstants.BLACK_ROOK:
            case GameConstants.WHITE_ROOK:
                icon = this.rookCapturedIcon;
                break;
            case GameConstants.BLACK_QUEEN:
            case GameConstants.WHITE_QUEEN:
                icon = this.queenCapturedIcon;
                break;
            default:
                break;
        }

        const capturedPieceImage = new Phaser.Image(this.game, capturedPiece.worldPosition.x, capturedPiece.worldPosition.y, "texture_atlas_1", capturedPiece.normalStateTextureName);
        capturedPieceImage.anchor.set(.5);
        capturedPieceImage.scale.y = GameVars.scaleY;

        const hud = BoardState.currentInstance.hud;
        hud.add(capturedPieceImage);

        // un tween hacia el icono
        // TODO: hacer que la velocidad de la pieza sea constante
        if (this.visible) {

            this.game.add.tween(capturedPieceImage)
                .to({x: icon.pieceImage.worldPosition.x, y: icon.pieceImage.worldPosition.y}, 650, Phaser.Easing.Cubic.Out, true);

        } else {

            let x = this.playerCapsule.plusButton.worldPosition.x;
            let y = this.playerCapsule.plusButton.worldPosition.y;

            if (this.isPlayer) {
                x += this.playerCapsule.plusButton.width * .5;
                y -= this.playerCapsule.plusButton.height * .5;
            } else {
                x += this.playerCapsule.plusButton.width * .5;
                y += this.playerCapsule.plusButton.height * .5;
            }

            this.game.add.tween(capturedPieceImage)
                .to({x: x, y: y}, 650, Phaser.Easing.Cubic.Out, true);
        }

        // aunque no se vea hay que contabiliazar la pieza capturada
        this.game.add.tween(capturedPieceImage.scale)
            .to({x: CapturedPiece.ICON_SCALE, y: CapturedPiece.ICON_SCALE * GameVars.scaleY}, 650, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {
                capturedPieceImage.destroy();
                icon.pieceCaptured();
            }, this); 
    }

    public show(): void {

        this.visible = true;

        this.game.add.tween(this)
            .to({x: 0}, 600, Phaser.Easing.Cubic.Out, true);
    }

    public hide(noTween?: boolean): void {
        
        let final_px: number;

        if (this.isPlayer) {
            final_px = -GameConstants.GAME_WIDTH;
        } else {
            final_px = GameConstants.GAME_WIDTH;
        }

        if (noTween) {
                this.visible = false;
                this.x = final_px;
        } else {
            this.game.add.tween(this)
                .to({x: final_px}, 750, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function(): void {
                    this.visible = false;
                }, this);
        }
    }

    public configurePieceIcons(): void {

        if (GameVars.fen === GameConstants.FEN_START) {
            return;
        }

        if (this.color === GameConstants.WHITE) {

            // contar los peones negros capturados
            const blackPawnsCaptured: number = this.countOcurrencies(GameConstants.BLACK_PAWN);
            this.pawnCapturedIcon.setCapturedPieces(blackPawnsCaptured);

            const blackKnightsCaptured: number = this.countOcurrencies(GameConstants.BLACK_KNIGHT);
            this.knightCapturedIcon.setCapturedPieces(blackKnightsCaptured);
            
            const blackBishopsCaptured: number = this.countOcurrencies(GameConstants.BLACK_BISHOP);
            this.bishopCapturedIcon.setCapturedPieces(blackBishopsCaptured);

            const blackRooksCaptured: number = this.countOcurrencies(GameConstants.BLACK_ROOK);
            this.rookCapturedIcon.setCapturedPieces(blackRooksCaptured);

            const blackQueensCaptured: number = this.countOcurrencies(GameConstants.BLACK_QUEEN);
            this.queenCapturedIcon.setCapturedPieces(blackQueensCaptured);

        } else {

            const whitePawnsCaptured: number = this.countOcurrencies(GameConstants.WHITE_PAWN);
            this.pawnCapturedIcon.setCapturedPieces(whitePawnsCaptured);
            
            const whiteKnightsCaptured: number = this.countOcurrencies(GameConstants.WHITE_KNIGHT);
            this.knightCapturedIcon.setCapturedPieces(whiteKnightsCaptured);

            const whiteBishopsCaptured: number = this.countOcurrencies(GameConstants.WHITE_BISHOP);
            this.bishopCapturedIcon.setCapturedPieces(whiteBishopsCaptured);

            const whiteRooksCaptured: number = this.countOcurrencies(GameConstants.WHITE_ROOK);
            this.rookCapturedIcon.setCapturedPieces(whiteRooksCaptured);
            
            const whiteQueensCaptured: number = this.countOcurrencies(GameConstants.WHITE_QUEEN);
            this.queenCapturedIcon.setCapturedPieces(whiteQueensCaptured);         
        }
    }

    private configurePositions(): void {

        let pawn_px = this.isPlayer ? 292 : 80;
        let pieces_py = this.isPlayer ? -44 : 40;
    
        this.pawnCapturedIcon.x = pawn_px;
        this.pawnCapturedIcon.y = pieces_py;

        let pieceDelta_x = 90;

        this.knightCapturedIcon.x = this.pawnCapturedIcon.x + pieceDelta_x;
        this.knightCapturedIcon.y = pieces_py;

        this.bishopCapturedIcon.x = this.knightCapturedIcon.x + pieceDelta_x;
        this.bishopCapturedIcon.y = pieces_py;

        this.rookCapturedIcon.x = this.bishopCapturedIcon.x + pieceDelta_x;
        this.rookCapturedIcon.y = pieces_py;

        this.queenCapturedIcon.x = this.rookCapturedIcon.x + pieceDelta_x;
        this.queenCapturedIcon.y = pieces_py;
    }

    private countOcurrencies(pieceType: string): number {

        let ret: number = GameVars.capturedPieces.filter(function(val: string): boolean {
                return val === pieceType;
        }).length;

        return ret;
    }
}
